// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var ContractRefundController = function ($scope, $routeParams, $location, $http, $filter, Contract, ProductInfo, ContractRefund, SharedParameters, gettextCatalog, gettext) {
    $scope.triggered = false;
    $scope.refundAmount = 0;

    let productInfo = ProductInfo.get(function () {
        $scope.contract = Contract.get({ contractId: $routeParams.contractId }, function () {
            $scope.plan = productInfo.PlanById($scope.contract.PlanId);
            $scope.planGroup = productInfo.PlanGroupById($scope.contract.PlanGroupId);
            $scope.currentCredit = $scope.contract.Balance < 0 ? -$scope.contract.Balance : 0;
        });
    });
    $scope.back = function (key, value) {
        if (key)
            SharedParameters.setValue(key, value);

        $location.path("/contracts/" + $routeParams.contractId);
    };
    $scope.refund = function () {
        if ($scope.triggered)
            return;
        $scope.triggered = true;
        ContractRefund.save({ contractId: $routeParams.contractId }, { amount: $scope.refundAmount }, function (data) {
                let link = null;
                if (data.IsPspError) {
                    link = { sentence: 'See details in ', text: 'logs', url: '#/logs/payment-refunds' }
                }
                if (data.Amount > data.RefundedAmount && data.RefundedAmount > 0 && data.Error != null) {
                    $scope.showWarningBox(data.Error, link);
                }
                if (data.RefundedAmount == 0 && data.Error != null) {
                    $scope.showErrorBox(data.Error, link);
                }
                let refundedSuccessfullyTxt = $filter('number')(data.RefundedAmount, 2) + ' ' + $scope.contract.Currency + ' ' + gettextCatalog.getString(gettext('refunded successfully'));
                if (data.Amount != data.RefundedAmount) {
                    let requestedForRefund = $filter('number')(data.Amount, 2) + ' ' + $scope.contract.Currency + ' ' + gettextCatalog.getString(gettext('requested refund'));
                    $scope.notify("error", requestedForRefund + ". " + refundedSuccessfullyTxt);
                } else
                    $scope.back('NotifyContract', { messageType: 'success', message: refundedSuccessfullyTxt });
            },
            function () {
                $scope.triggered = false;
            }
        );
    };

};
ContractRefundController.$inject = ['$scope', '$routeParams', '$location', '$http', '$filter', 'Contract', 'ProductInfo', 'ContractRefund', 'SharedParameters', 'gettextCatalog', 'gettext'];
